import { SelectMockContainer } from '@tino-frontend/mocks'
import { REACT_APP_ENV } from 'constants/envs'
import { mockDebugAllMocks } from 'modules/mock-debug/index'
import { useLogout } from 'modules/auth'
import { Button } from '@tino-frontend/coreui'
import { formatDate } from 'lib/dates'

export function MockDebugContainer() {
  const { logout } = useLogout()

  function generateEmailToSignUp() {
    const newDate = new Date()
    const hours = newDate.getHours()
    const minutes = newDate.getMinutes()

    const date = formatDate(undefined, '-')
    navigator.clipboard.writeText(
      `e2e.teste-de-cadastro-${date}-${hours}${minutes}@tino.com.br`
    )
  }

  return (
    <SelectMockContainer
      render={REACT_APP_ENV !== 'prd'}
      mocks={mockDebugAllMocks}
    >
      <Button
        color="secondary"
        variant="contained"
        onClick={logout}
        sx={{ mr: 2 }}
      >
        Logout
      </Button>
      <Button
        color="secondary"
        variant="contained"
        onClick={generateEmailToSignUp}
      >
        Copy email to sign up
      </Button>
    </SelectMockContainer>
  )
}
